






















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import {
  detailUser,
  userHierarchy
} from '@/pages/users/api/index'
import OrgTree from '@/components/OrgTree/index.vue'
@Component({
  name: 'UserDetailDialog',
  components: {
    OrgTree
  }
})
export default class extends Vue {
  @Prop() private dialog!: any
  @Prop() private editData!: {}
  /// // 功能函数 /////
  private superiorName = ''
  private hierachyData = {}
  /// // ui /////
  // 表单取消
  private handleClose() {
    this.dialog.isViewVisible = false
  }
  @Watch('editData')
  getSuperior(value: any) {
    if (value.superior && value.superior !== '-1') {
      this.getSuperiorName(value.superior)
    }
  }
  /// // 功能函数 /////
  // 获取详情
  private async getSuperiorName(id: string) {
    const { data } = await detailUser(id)
    if (data.isSuccess === true) {
      if (data.data) {
        this.superiorName = data.data.name
      }
    }
  }
  // 初始化
  private init() {
    this.getUserHierarchy()
  }
  // 加载关系图数据
  private async getUserHierarchy() {
    const { data } = await userHierarchy((this.editData as any).id)
    if (data.isSuccess === true) {
      this.hierachyData = data.data
    }
  }
}
